import React, { useState } from 'react'
import { Tooltip } from 'antd'
import { useTranslation } from 'react-i18next'
import { Badge } from '../../../ui/badge/component/badge/Badge'
import { IconCross } from '../../../../shared/components/icons/IconCross'
import { TriangleButton } from '../../../../shared/components/buttons/triangle/TriangleButton'
import { AlertType } from '../model/alerting'

const VISIBLE_COUNT = 3

export interface IRecipientChip {
  value: string
  /** Теги типов подписки; не передаются — чип без тегов */
  tags?: AlertType[]
}

interface IRecipientChipsProps {
  /** Последний добавленный — первым */
  items: IRecipientChip[]
  removeTooltip: string
  onRemove: (value: string) => void
}

export const RecipientChips = ({ items, removeTooltip, onRemove }: IRecipientChipsProps) => {
  const { t } = useTranslation()
  const [expanded, setExpanded] = useState(false)

  if (!items.length) {
    return (
      <p className={'px-[2px] text-[13px] text-[#8E7CA7]'}>
        {t('components.alertingSchedule.addRecipientHint')}
      </p>
    )
  }

  const collapsible = items.length > VISIBLE_COUNT
  const visible = collapsible && !expanded ? items.slice(0, VISIBLE_COUNT) : items

  return (
    <div className={'flex min-w-0 flex-col gap-[6px] px-[2px]'}>
      {visible.map(({ value, tags }, index) => (
        <div key={value} className={'flex min-w-0 items-center gap-[8px]'}>
          <div
            className={
              'flex min-w-0 max-w-full items-center gap-[8px] rounded-[6px] bg-white pl-[8px] shadow-outline shadow-default'
            }
          >
            <Tooltip title={value}>
              <span className={'truncate py-[6px] text-focus-500'}>{value}</span>
            </Tooltip>
            {!!tags?.length && (
              <div className={'flex items-center gap-[4px]'}>
                {tags.includes('affiliates') && (
                  <Badge color={'purple'} variant={'light'}>
                    {t('components.alertingSchedule.tags.affiliates')}
                  </Badge>
                )}
                {tags.includes('tm_infringements') && (
                  <Badge color={'grey'} variant={'light'}>
                    {t('components.alertingSchedule.tags.tm_infringements')}
                  </Badge>
                )}
              </div>
            )}
            <Tooltip title={removeTooltip}>
              <button
                className={'flex items-center self-stretch border-l border-l-[#E5E1EA] px-[9px]'}
                type='button'
                onClick={() => onRemove(value)}
              >
                <span className={'inline-block w-[14px]'}>
                  <IconCross color={'#6684A7'} />
                </span>
              </button>
            </Tooltip>
          </div>
          {collapsible && index === visible.length - 1 && (
            <button
              aria-expanded={expanded}
              className={'flex shrink-0 items-center px-[4px]'}
              type='button'
              onClick={() => setExpanded(!expanded)}
            >
              <TriangleButton color={'#001c44'} position={expanded ? 'top' : 'down'} />
            </button>
          )}
        </div>
      ))}
    </div>
  )
}
